import { BaseAlertBar } from './Base';
import { FloatAlertBar } from './FloatAlertBar';
import { MixedAlertBar } from './Mixed';

export const AlertBar = {
  Base: BaseAlertBar,
  Float: FloatAlertBar,
  Mixed: MixedAlertBar,
};
